import type { Scenario } from "@/types";

export const CATEGORY_OPTIONS: readonly { value: Scenario["category"] | ""; label: string }[] = [
  { value: "", label: "All Categories" },
  { value: "batting", label: "Batting" },
  { value: "baserunning", label: "Baserunning" },
  { value: "fielding", label: "Fielding" },
  { value: "pitching", label: "Pitching" },
  { value: "situational", label: "Situational" },
] as const;

export const DIFFICULTY_OPTIONS: readonly { value: Scenario["difficulty"] | ""; label: string }[] = [
  { value: "", label: "All Levels" },
  { value: "rookie", label: "Rookie" },
  { value: "veteran", label: "Veteran" },
  { value: "allstar", label: "All-Star" },
] as const;

export function formatLabel(label: string): string {
  return label.charAt(0).toUpperCase() + label.slice(1);
}
